export const formatResetProgressToast = (result = {}, { name, campaignState } = {}) => {
  const updated = result.updated ?? 0
  const target = campaignState === 'completed' ? 'Overdue' : 'Not started'
  if (updated === 1 && name) {
    return `${name} reset to ${target}.`
  }
  if (updated === 1) {
    return `1 participant reset to ${target}.`
  }
  if (updated > 1) {
    return `${updated} participants reset to ${target}.`
  }
  return 'No participants were reset.'
}
